import { createSelector } from 'reselect'
import sessionIdSelector from './sessionIdSelector'

const sessionIdIsSetSelector = createSelector(
    sessionIdSelector,
    (sessionId): boolean => sessionId !== '',
)

export default sessionIdIsSetSelector
